module.exports = __webpack_public_path__ + "bh.no2.f1eeec38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/bh.no2.jpg
// module id = MCBu
// module chunks = 0